import { dataDatabaseSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDatabaseSolid = /*#__PURE__*/createIcon(dataDatabaseSolid)
export default IconDatabaseSolid
